import React from "react"
import { Form } from "react-bootstrap"
import { Rating } from "react-simple-star-rating"
import { RatingHook } from "../Componentslogic/thankyouLogic/ratingHook"
import { Link, useLocation } from "react-router-dom"
import { motion as m } from "framer-motion"
const Ratingcomponent = ({ orderID, closeModal }) => {
  const [text, handleRating, handleText, handleRatingFood, onSubmitrating] =
    RatingHook(orderID, closeModal)

  return (
    <m.div
      className="my-3 "
      style={{ textAlign: "center" }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div>
        <h6 className=" text">How Was Our Service?</h6>
        <Rating onClick={handleRating} />
      </div>

      <div>
        <h6 className=" text mt-4 mb-2">How Did You Enjoy Your Meal?</h6>
        <Rating onClick={handleRatingFood} />
      </div>

      <Form className="mt-3">
        <div>
          <Form.Group controlId="exampleForm.ControlTextarea1">
            <Form.Label className="title-Experience">
              Leave Feedback?
            </Form.Label>
            <Form.Control
              value={text}
              onChange={handleText}
              as="textarea"
              rows={3}
            />
            <div className="d-flex justify-content-center my-2">
              <button onClick={onSubmitrating} className="button">
                Submit
              </button>
            </div>
          </Form.Group>
        </div>
      </Form>
    </m.div>
  )
}
export default Ratingcomponent
